var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaExpertHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0383 35.9998L0 18L10.2287 0.000270479L30.6898 0L41 18L30.5 36L10.0383 35.9998Z",
    fill: "url(#paint0_linear_4084_103021)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4258 5.99814L6.80664 5.99805L8.3099 10.7603L15.4639 10.8076C17.3877 10.8076 18.3496 11.7695 18.3496 13.2124C18.3496 14.6553 17.3877 15.6172 15.4639 15.6172C13.7998 15.6602 12.0569 15.6456 10.3396 15.6313C9.47152 15.6241 8.60999 15.6169 7.76855 15.6172V25.2363H12.5781V19.5626H16.3858C19.7925 19.4648 23.1453 17.541 23.1453 13.2124C23.1453 8.65682 19.7925 5.99814 16.4258 5.99814ZM30.3952 12.6366C29.0828 12.6539 27.7711 12.6538 26.46 12.6365C26.3476 12.6228 26.2342 12.6523 26.1416 12.7193C26.049 12.7864 25.9838 12.8862 25.9585 12.9996C25.4383 14.3081 24.9146 15.6152 24.3909 16.9223C23.6792 18.6988 22.9672 20.4758 22.2638 22.2569C21.3625 24.5394 20.4754 26.8219 19.5884 29.1044L19.5866 29.109C19.2913 29.8687 18.9961 30.6284 18.7003 31.3881C18.6641 31.4791 18.6313 31.5719 18.5943 31.6763C18.5729 31.7366 18.5502 31.8008 18.5247 31.8708C18.8142 31.8708 19.1023 31.871 19.3892 31.8711L19.3941 31.8711C20.8287 31.872 22.2327 31.8729 23.635 31.8512C23.7408 31.849 23.8508 31.8512 23.8508 31.8512C23.9926 31.4676 24.1588 30.9965 24.318 30.5273L24.3168 30.5271L24.5136 29.941C24.5858 29.7205 24.6532 29.5095 24.7121 29.3184C24.7288 29.2644 24.7478 29.2147 24.7724 29.1704L25.1574 28.0237L35.1262 28.0238L33.4215 24.1762H26.3644L28.447 18.0478L28.4492 18.0539L30.3952 12.6366Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4084_103021",
    x1: 35.9999,
    y1: 9.61951,
    x2: 9.60798,
    y2: 31.1843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED006D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#8B237B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00548E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaExpertHeader);
export default __webpack_public_path__ + "static/media/pa-expert-header.5bf65333a500f82aa213bcd01e47c0a5.svg";
export { ForwardRef as ReactComponent };